import axiosInstance from '@/utils/api.js'

var state = {
  telephonyDirections: []
}

var getters = {
  TELEPHONY_DIRECTIONS: (state) => {
    return state.telephonyDirections
  }
}

var mutations = {
  SET_TELEPHONY_DIRECTIONS: (state, payload) => {
    state.telephonyDirections = payload
  }
}

var actions = {
  GET_TELEPHONY_DIRECTIONS: async (context, payload) => {
    let result = await axiosInstance.get('/reports/tel_directions?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&account_id=0&accounting_period_id=0' +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_TELEPHONY_DIRECTIONS', result.data)
    }
  },
  CLEAR_TEL_DIRS: (context) => {
    context.commit('SET_TELEPHONY_DIRECTIONS', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/telephonyDirections.js